var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.5V8.5C16 7.4 16.392 6.458 17.176 5.674C17.96 4.89 18.9013 4.49867 20 4.5H28C29.1 4.5 30.042 4.892 30.826 5.676C31.61 6.46 32.0013 7.40134 32 8.5V12.5H40C41.1 12.5 42.042 12.892 42.826 13.676C43.61 14.46 44.0013 15.4013 44 16.5V26.5H30V22.5H18V26.5H4V16.5C4 15.4 4.392 14.458 5.176 13.674C5.96 12.89 6.90134 12.4987 8 12.5H16ZM20 12.5H28V8.5H20V12.5ZM22 30.5V26.5H26V30.5H22ZM4 30.5H18V34.5H30V30.5H44V38.5C44 39.6 43.608 40.542 42.824 41.326C42.04 42.11 41.0987 42.5013 40 42.5H8C6.9 42.5 5.958 42.108 5.174 41.324C4.39 40.54 3.99867 39.5987 4 38.5V30.5Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutBusiness);
export default __webpack_public_path__ + "static/media/aboutBusiness.8fca33abdb0b9ab5b7434962070d4e5b.svg";
export { ForwardRef as ReactComponent };